var _path, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMessageIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3877_1175)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_3877_1175)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_3877_1175)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3877_1175",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 25,
    height: 25
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.1001 0.769531H0.100098V24.7695H24.1001V0.769531Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3877_1175)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.7668 18.7695H11.4334L6.1001 22.7695V18.7695H3.43343C3.07981 18.7695 2.74067 18.629 2.49062 18.379C2.24058 18.1289 2.1001 17.7898 2.1001 17.4362V4.10286C2.1001 3.74924 2.24058 3.4101 2.49062 3.16005C2.74067 2.91001 3.07981 2.76953 3.43343 2.76953H20.7668C21.1204 2.76953 21.4595 2.91001 21.7096 3.16005C21.9596 3.4101 22.1001 3.74924 22.1001 4.10286V17.4362C22.1001 17.7898 21.9596 18.1289 21.7096 18.379C21.4595 18.629 21.1204 18.7695 20.7668 18.7695Z",
    stroke: "#F94B25",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3877_1175"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.100098 0.769531)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_3877_1175"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.100098 0.769531)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_3877_1175"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.100098 0.769531)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageIcon);
export default __webpack_public_path__ + "static/media/MessageIcon.7634be8668f4f834498a8b0d0fccf38d.svg";
export { ForwardRef as ReactComponent };